import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

interface PropsTypes {
    sportState: CustomizedSportsState
}

export const NewSportsForm = observer('NewSportsForm', ({ sportState }: PropsTypes) => {
    const {
        sportSlug,
        sportLabel,
        handleCreate,
        handleResetForm,
        handleEdit,
        isEditMode,
        isLoading,
        competitionIdsInput
    } = sportState;

    return (
        <>
            <FormComponent onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                e.preventDefault();
            }}>
                <Loader isActive={isLoading}/>

                <Input
                    label='Sport slug'
                    formInputState={sportSlug}
                    dataTest='customize-new-sport-slug'
                />
                <Input
                    label='Sport label'
                    formInputState={sportLabel}
                    dataTest='customize-new-sport-label'
                />

                <Textarea
                    formState={competitionIdsInput}
                    label='Competition ids (use comma to separate competition ids)'
                    dataTest='customize-new-sport-competition'
                />

            </FormComponent>

            <FormButtons
                onCreate={handleCreate}
                onUpdate={handleEdit}
                onCancel={handleResetForm}
                isEditMode={isEditMode}
                dataTestCancel='customize-sport-cancel'
                dataTestCreate='customize-sport-create'
                dataTestUpdate='customize-sport-update'
            />
        </>
    );
});


